(() => {
  if (!window.matchMedia("(max-width: 749px)").matches) return;

  const ACTIVE_CLASS = "is-mobile-secondary";

  function inView(el) {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.50 && r.bottom > window.innerHeight * 0.60;
  }

  function update() {
    document.querySelectorAll(".card-wrapper").forEach(card => {
      const media = card.querySelector(".media--hover-effect");
      if (!media) return;

      const imgs = media.querySelectorAll("img");
      if (imgs.length < 2) return;

      if (inView(card)) card.classList.add(ACTIVE_CLASS);
      else card.classList.remove(ACTIVE_CLASS);
    });
  }

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  document.addEventListener("shopify:section:load", update);

  update();
})();


